import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CountdownTimer from '../_components/CountDownTimer';
import { Path } from '../_components/Path';
import { examService } from '../_services/exam.service';
import { isEnglish } from '../_helpers';
import { GrandQuizSingle } from './GrandQuizSingle';
import { Overview } from './Overview';

export const GrandQuiz = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { grandQuiz } = location.state;

  const [query, setQuery] = useState({
    pageVo: {
      pageNo: 1,
      noOfItems: 100,
    },
  });
  const [isLoading, setIsLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [mockEnd, setMockEnd] = useState(false);
  const [currentExamTime, setCurrentExamTime] = useState(0);
  console.log(isLoading, 'renderingg====', grandQuiz, 'Questions===', mockEnd);
  useEffect(() => {
    if (grandQuiz) {
      getQuestionAnswerWithPrevNext({
        edraakquizid: grandQuiz?._id,
      });
    }
  }, [grandQuiz]);

  useEffect(() => {
    if (mockEnd) {
      // navigate('/examresult', { state: { topicData: grandQuiz, mode: 3 } });
      navigate('/edraaquizresult', {
        state: { edraaquizId: grandQuiz?._id, currentExamTime: grandQuiz?.time_duration },
      });
    }
  }, [mockEnd]);

  function getQuestionAnswerWithPrevNext(queryTemp) {
    let queryNew = queryTemp ? queryTemp : query;
    // queryNew.mocktest_id = mocktest_id;

    setQuery(queryNew);
    // queryNew.mode = 3;
    // queryNew.attempt = 1;
    examService.getQuestionAnswerWithPrevNextforGrandQuiz(queryNew).then(
      (res) => {
        // if (res.data == 0) {
        //   navigate('/examresult', { state: { topicData: mockTest, mode: 3 } });
        // }
        if (res.data) {
          setIsLoading(false);
          setQuestions(res.data);
        } else {
          setIsLoading(false);
          setQuestions({});
        }
      },
      (err) => {
        setIsLoading(false);
        console.error('error from getQuestionAnswerWithPrevNext', err);
      },
    );
  }
  const getCurrentTime = (time) => {
    console.log('inside getcurrenttimme', time);
    setCurrentExamTime(time);
  };
  {
    console.log(currentExamTime, 'this is currentextra time');
  }
  const handleNext = (nextId, order, currentId) => {
    if (questions.answer && questions.index + 1 == questions.length) {
      // navigate('/examresult', { state: { topicData: grandQuiz, mode: 3 } });
      navigate('/edraaquizresult', {
        state: { edraaquizId: grandQuiz?._id, currentExamTime: currentExamTime },
      });
    }
    getQuestionAnswerWithPrevNext({
      question_id: nextId,
      edraakquizid: grandQuiz?._id,
      isNext: true,
      currentOrder: order,
      currentQuesId: currentId,
    });
  };
  const handlePrev = (prevId, order, currentId) => {
    getQuestionAnswerWithPrevNext({
      question_id: prevId,
      edraakquizid: grandQuiz?._id,
      isPrev: true,
      currentOrder: order,
      currentQuesId: currentId,
    });
  };

  return (
    <div className='exam'>
      {!isLoading && (
        <div className='container'>
          <Path pathList={[{ name: 'Grand Quiz' }]} />
          {grandQuiz?.name && (
            <div
              className={'topicname ' + (isEnglish(grandQuiz?.name) ? 'ltrtext' : 'rtltext')}
            >
              {grandQuiz?.name}
            </div>
          )}
          {grandQuiz?._id && (
            <div
              className={
                'd-flex gap-2 ' +
                (isEnglish(grandQuiz?.name) ? 'justify-content-start' : 'justify-content-end')
              }
            >
              <div className='descitem'>
                <img src='/img/question_icon.png' className='desc_icon' />{' '}
                {parseInt(grandQuiz?.edraaquiz_count)} Questions
              </div>

              <div className='examlabel testlbl'>Quiz</div>
            </div>
          )}
          <CountdownTimer
            durationInSeconds={grandQuiz?.time_duration ? grandQuiz?.time_duration : 3600}
            // durationInSeconds={120}
            setMockEnd={setMockEnd}
            getCurrentTime={getCurrentTime}
          />
          <div className='d-flex flex-wrap'>
            <GrandQuizSingle
              question={questions}
              totalQuestions={questions?.length}
              handleNext={handleNext}
              handlePrev={handlePrev}
              attempt={1}
            />
            <Overview QnLength={questions?.length} item={questions} />
          </div>
        </div>
      )}
    </div>
  );
};
